<div class="rounded-2xl bg-white p-6 filters-shadow">
  <div class="mb-5 grid grid-cols-4 gap-6">
    <div>
      <app-filter-item-search
        [label]="invoiceIdFilter"
        [placeholder]="invoiceIdPlaceholder"
        [isInvalid]="!!invoiceIdError()"
        [(searchTerm)]="invoiceSearch" />

      @if (invoiceIdError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ invoiceIdError() }}
        </p>
      }
    </div>

    <div>
      <app-filter-item-search
        [label]="orderIdFilter"
        [placeholder]="orderIdPlaceholder"
        [isInvalid]="!!orderIdError()"
        [(searchTerm)]="orderSearch" />

      @if (orderIdError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ orderIdError() }}
        </p>
      }
    </div>
      <app-filter-multi-select
      [label]="statusFilter"
      [items]="statusOptions()"
      [placeholder]="allStatuses"
      [(selectedIds)]="selectedStatuses"
      [showDropdown]="showStatusDropdown()"
      (toggleDropdown)="toggleStatusDropdown()"
      (selectionChange)="onStatusChange($event)" />
  </div>
  <div class="mb-6 grid grid-cols-4 gap-6">
    <div>
     <app-filter-date-component
    [label]="invoiceDateFrom"
    [value]="invoiceFrom()"
    (valueChange)="onFromDateChange($event)" />

  @if (fromDateError()) {
    <p class="mt-1 text-xs text-red-500">
      {{ fromDateError() }}
    </p>
  }
</div>

<div>
  <app-filter-date-component
    [label]="invoiceDateTo"
    [value]="invoiceTo()"
    (valueChange)="onToDateChange($event)" />

  @if (toDateError()) {
    <p class="mt-1 text-xs text-red-500">
      {{ toDateError() }}
    </p>
  }
</div>
  </div>
  <hr class="mb-5 border-gray-200" />

  <div class="flex items-center justify-between">
    <app-filter-sorting-component
      [(orderBy)]="orderBy"
      [orderDir]="orderDir()"
      [sortOptions]="sortOptions"
      (toggleOrder)="toggleSortOrder()" />

    <div class="flex gap-3">
      <app-submit-button type="secondary" (click)="resetFilters()">
        <span i18n="@@invoiceListReset">Clear</span>
      </app-submit-button>

      <app-submit-button type="primary" (click)="applyFilters()">
        <span i18n="@@invoiceListApply">Apply</span>
      </app-submit-button>
    </div>
  </div>
</div>


<div class="mt-6  p-6 ">
 @if (loading()) {
      <div class="flex min-h-[300px] items-center justify-center">
        <app-loading />
      </div>
    } @else if (errorMessage2()) {
      <app-error-data [title]="errorMessage2()!" />
    } @else {

<app-cards-list
  [headerItems]="headerItems()"
  [rows]="tableRows()"
  [currentActions]="actions()"
  [isFiltersApplied]="isFilterActive()"
  [emptyContentTitle]="isArabic() ? emptyContentTitle.ar : emptyContentTitle.en"
  [emptyFilterTitle]="isArabic() ? emptyFilterTitle.ar : emptyFilterTitle.en"
  (actionTrigger)="handleAction($event)"
/>
    }

  </div>

  <div class="mt-3 rounded-2xl bg-white p-2 shadow-md">
  <app-pagination
      [itemsPerPage]="itemsPerPage()"
      [currentPage]="currentPage()"
      [getPageNumbers]="getPageNumbers()"
      [totalPages]="totalPages()"
      [startItem]="startItem()"
      [endItem]="endItem()"
      [totalItems]="totalItems()"
      (previousPage)="onPreviousPage()"
      (nextPage)="onNextPage()"
      (goToPage)="onGoToPage($event)"
      (changePageNumber)="onChangePageNumber($event)"
      (pageSizeChange)="onPageSizeChange()" />
  </div>